import React from "react";
import { METRICS } from "../core/model/palette";

/**
 * Periods · PMS · Energy · Cravings, as dark pills.
 *
 * @param {Object} props
 * @param {string} props.active - Active metric id.
 * @param {(id: string) => void} props.onPick
 * @param {Array<{id: string, name: string}>} [props.tabs] - Defaults to the hormone metrics.
 * @param {string} [props.label] - The tablist's accessible name.
 */
const MetricTabs = ({ active, onPick, tabs = METRICS, label = "Metric" }) => (
  <div role="tablist" aria-label={label} className="flex gap-[6px] pt-[6px]">
    {tabs.map((m) => {
      const on = m.id === active;
      return (
        <button
          key={m.id}
          type="button"
          role="tab"
          aria-selected={on}
          onClick={() => onPick(m.id)}
          className={`px-[16px] py-[9px] rounded-[8px] text-[14px] cursor-pointer transition-colors duration-200 ${
            on
              ? "bg-[#1f1f1f] text-white font-semibold border border-[#1f1f1f]"
              : "bg-white border border-[#ECECEC] text-[#3a3a3a] hover:bg-[#F6F2EF]"
          }`}
        >
          {m.name}
        </button>
      );
    })}
  </div>
);

export default MetricTabs;
